module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row top-margined" id="doc-types-list">\r\n    <h3 class="center">Document types</h3>\r\n    <div id="document-types"></div>\r\n    <div id="document-type-form" class="col-xs-12 col-md-12"></div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/document-types/document-types-view.html
// module id = 459
// module chunks = 0